<script type="text/babel">
import ChatThreadsBar from 'dashboard-js/components/ChatThreadsBar'
import ClickOutside from 'dashboard-js/directives/ClickOutside'
import NotificationsBar from 'dashboard-js/components/NotificationsBar'

export default {
    components: {
        ChatThreadsBar,
        NotificationsBar,
    },

    directives: {
        ClickOutside,
    },
    props: ['user', 'currentTeam'],

    data() {
        return {
            menuItemsOpen: false,
        }
    },

    methods: {
        showSupportForm() {
            Bus.$emit('showSupportForm')
        },

        blurMenuItems(event) {
            if (this.menuItemsOpen) {
                this.menuItemsOpen = false
                event.preventDefault()
                event.stopPropagation()
            }
        },

        toggleMenuItems() {
            this.menuItemsOpen = !this.menuItemsOpen
        },
    },
}
</script>
